import { AbstractBlock } from '../AbstractBlock';
import { CodeSetting } from '../setting/CodeSetting';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;

const VALUE = 'VALUE';
export class NotOperatorBlock extends AbstractBlock {
  constructor() {
    super('logic_not_v2', t.to('ではない', 'operator_not'));
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setOperatorColor(block);
    ShapeSettings.setOperatorBoolShape(block);
    block.appendValueInput(VALUE).setCheck('Boolean').appendField(t.to('ではない', 'operator_not'));
  }

  codeGenerateCore(block: BlockType): string[] {
    const value = CodeSetting.getInputValue(block, VALUE);
    const str = `!( ${value} )`;
    return [str];
  }
}
